import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useHistory, useLocation } from "react-router";
import {
  ArrowUpRightBlue,
  BackwardArrow,
  ForwardArrow,
  left_arrow,
} from "../../../../constant/imagePath";
import { AfterLoginHeader } from "../../../../stories/AfterLoginHeader/AfterLoginHeader";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { DashboardBookingDetailCard } from "../../../../stories/DashboardBookingDetailCard/DashboardBookingDetailCard";
import { HeadingWithList } from "../../../../stories/HeadingWithList/HeadingWithList";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Footer } from "../../../../stories/Footer/Footer";
import PaymentMethodCard from "../../../../stories/PaymentMethodCard/PaymentMethodCard";
import classes from "./UpcomingLesson.module.css";
import { ReactSVG } from "react-svg";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import UpcomingLessonMobile from "./UpcomingLessonMobile";

function UpcomingLessonDesktop() {
  const history = useHistory();
  const location = useLocation();
  // const [data, setData] = useState();
  const type = location?.state?.data?.type;
  // const type = "completed";

  const whatsProvided = {
    heading: "What's provided",
    lists: [
      { title: "Grips", icon: true },
      { title: "Racquet string", icon: true },
      { title: "Tennis racquet", icon: true },
      { title: "Tennis Balls", icon: true },
      { title: "Practice Skirt", icon: true },
      { title: "Sweatbands", icon: true },
    ],
  };
  const whatToBring = {
    heading: "What to bring",
    lists: [
      { title: "Grips", icon: false },
      { title: "Racquet string", icon: false },
      { title: "Tennis racquet", icon: false },
      { title: "Tennis Balls", icon: false },
      { title: "Practice Skirt", icon: false },
      { title: "Sweatbands", icon: false },
    ],
    tagline:
      "Things that the coach does not provide should be taken by yourself.",
  };

  return (
    <div className={classes.page}>
      <div className={classes.header}>
        <AfterLoginHeader showSearch />
      </div>
      <Container fluid className={classes.container}>
        <Row className="gx-5">
          <Col xl={7} lg={6} xxl={8}>
            <Row>
              <Col
                md={12}
                className={`${[classes.pb32, classes.borderBtm].join(" ")}`}
              >
                <LinkButtonWithIcon
                  primary={false}
                  leftIcon={BackwardArrow}
                  text={"Go Back"}
                  onClick={() => history.goBack()}
                />
                <h3
                  style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
                  className={`${[classes.mb24].join(" ")}`}
                >
                  1-on-1 Tennis Lesson with Michael Baumgardner
                </h3>
                {type == "completed" && (
                  <div
                    className={classes.lessonCompletedBox}
                    style={{ background: Colors.neutralShadesOfWhiteSmoke }}
                  >
                    <div>
                      <h6
                        style={{
                          ...Fonts.h7,
                          fontFamily: "inter-600",
                          lineHeight: "24px",
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        How was your lesson?
                      </h6>
                      <p
                        className={classes.mt8}
                        style={{
                          ...Fonts.b2,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                      >
                        Tell us about your experiecne with Michael Baumgardner.
                      </p>
                    </div>
                    <div>
                      <ReactSVG
                        src={ForwardArrow}
                        beforeInjection={(svg) =>
                          svg.classList.add(classes.icon)
                        }
                      />
                    </div>
                  </div>
                )}
                <p
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
                >
                  Every session is based on the athlete's skill level and prior
                  knowledge of the sport. If my student needs to work on
                  improving a specific move or drill for a team or their own
                  personal aspirations, I am always open to working through it.
                </p>
                <ul
                  className={`${[classes.mt16, classes.description].join(" ")}`}
                >
                  <li
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    1. Footwork{" "}
                  </li>
                  <li
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    2. Proper serve
                  </li>
                  <li
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    3. Balance and reflex response
                  </li>
                  <li
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    2. Fore-hand and back-hand drills
                  </li>
                  <li
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    2. Hustle Drills
                  </li>
                  <li
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    2. Playing at the Net
                  </li>
                  <li
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                    }}
                  >
                    2. Doubleheader Match - 15 minutes
                  </li>
                </ul>
              </Col>
              <Col
                md={12}
                className={`${[
                  classes.mt32,
                  classes.pb32,
                  classes.borderBtm,
                ].join(" ")}`}
              >
                <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                  Notes from the coach
                </h5>
                <p
                  style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
                  className={classes.mt16}
                >
                  Please bring a tennis racket. See you then!
                </p>
              </Col>

              <Col
                md={12}
                className={`${[classes.mt32, classes.borderBtm].join(" ")}`}
              >
                <HeadingWithList {...whatsProvided} />
              </Col>
              <Col
                md={12}
                className={`${[classes.mt32, classes.borderBtm].join(" ")}`}
              >
                <HeadingWithList {...whatToBring} />
              </Col>

              <Col
                md={12}
                className={`${[
                  classes.mt32,
                  classes.pb32,
                  classes.borderBtm,
                ].join(" ")}`}
              >
                <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
                  Getting there
                </h5>
                <div className={classes.mt24}>
                  <h6
                    style={{ ...Fonts.h7, color: Colors.neutralShadesOfNero }}
                  >
                    Royal Tennis Court
                  </h6>
                  <p
                    style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
                    className={classes.mt8}
                  >
                    DeWitt Clinton Park, W 54th St, New York, NY
                  </p>
                  <div className={classes.mt24}>
                    <LinkButtonWithIcon
                      primary={true}
                      rightIcon={ArrowUpRightBlue}
                      text={"Get directions"}
                      iconStyle={{ marginLeft: "8px" }}
                      customStyle={{ fontSize: "16px", lineHeight: "16px" }}
                    />
                  </div>
                </div>
              </Col>

              <Col md={12} className={classes.mt32}>
                <PaymentMethodCard
                  data={{
                    type: "master",
                    title: "Paid with card ending",
                    number: ".... 0084",
                    description: "This is your default payment method",
                    date: "Aug 12, 2021",
                    time: "02:06pm",
                    amount: "75",
                  }}
                  isDone={true}
                />
              </Col>
            </Row>
          </Col>
          <Col xl={5} lg={6} xxl={4}>
            <DashboardBookingDetailCard />
          </Col>
        </Row>
      </Container>
      <div className={classes.footer}>
        <Footer />
      </div>
    </div>
  );
}

function UpcomingLesson() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  return isMobile ? <UpcomingLessonMobile /> : <UpcomingLessonDesktop />;
}

export default UpcomingLesson;
